(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.formly.inputs.datepicker'
  var templateUrl = require('./tpl/datepicker.html')
  var popupTemplate = require('./tpl/datepicker-popup.html')

  require('./scss/datepicker.scss')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap'),
      require('angular-ui-bootstrap/src/datepickerPopup/index')
    ])
    .run(datepickerConfig)

  datepickerConfig.$inject = ['formlyConfig']
  function datepickerConfig (formlyConfig) {
    formlyConfig.setType({
      name: 'datepicker',
      templateUrl: templateUrl,
      defaultOptions: {
        templateOptions: {
          templateUrl: popupTemplate,
          ngModelOptions: {
            timezone: 'UTC'
          },
          datepickerOptions: {
            format: 'MM/dd/yyyy',
            showWeeks: false
          }
        }
      },
      wrapper: ['bootstrapLabel', 'bootstrapHasError'],
      controller: datepickerController
    })
  }

  datepickerController.$inject = ['$scope']
  function datepickerController ($scope) {
    $scope.datepicker = {}
    $scope.datepicker.opened = false
    $scope.datepicker.open = ($event) => {
      $scope.datepicker.opened = !$scope.datepicker.opened
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/datepicker.js